const info = [
  { label: "所在地", value: "〒612-8449 京都府京都市伏見区竹田西小屋ノ内町13" },
  { label: "電話番号", value: "0120-02-4747" },
  { label: "事業内容", value: "不用品回収 / 遺品整理 / ゴミ屋敷清掃 / 残置物撤去 / 産業廃棄物収集運搬" },
  { label: "対応エリア", value: "京都市" },
  { label: "営業時間", value: "9:00〜17:00" },
  { label: "定休日", value: "年中無休" },
  { label: "許可番号", value: "京都府知事 一般廃棄物・産業廃棄物収集運搬業許可" },
];

export default function Company() {
  return (
    <section id="company" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            COMPANY
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            会社概要
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10 items-start">
          <div className="rounded-lg bg-background-50 border border-background-200 overflow-hidden">
            <table className="w-full text-sm md:text-base">
              <tbody>
                {info.map((row) => (
                  <tr
                    key={row.label}
                    className="border-b border-background-200 last:border-b-0"
                  >
                    <th className="w-32 md:w-40 px-5 md:px-6 py-4 bg-secondary-100 text-secondary-900 text-left font-bold align-top">
                      {row.label}
                    </th>
                    <td className="px-5 md:px-6 py-4 text-foreground-800 leading-relaxed">
                      {row.value}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="rounded-lg overflow-hidden border border-background-200 bg-background-50">
            <div className="aspect-[4/3] w-full">
              <iframe
                title="京都ゴミ処分センター アクセスマップ"
                src="https://www.google.com/maps?q=%E4%BA%AC%E9%83%BD%E5%BA%9C%E4%BA%AC%E9%83%BD%E5%B8%82%E4%BC%8F%E8%A6%8B%E5%8C%BA%E7%AB%B9%E7%94%B0%E8%A5%BF%E5%B0%8F%E5%B1%8B%E3%83%8E%E5%86%85%E7%94%BA13&t=m&z=16&output=embed"
                loading="lazy"
                className="w-full h-full border-0"
              ></iframe>
            </div>
            <div className="p-5 md:p-6">
              <div className="flex items-center gap-2 text-foreground-700 text-sm mb-3">
                <i className="ri-map-pin-line text-primary-600"></i>
                <span>京都府京都市伏見区竹田西小屋ノ内町13</span>
              </div>
              <div className="grid grid-cols-2 gap-3 text-xs md:text-sm">
                <div className="flex items-center gap-2 text-foreground-700">
                  <i className="ri-time-line text-accent-700"></i>
                  <span>9:00〜17:00</span>
                </div>
                <div className="flex items-center gap-2 text-foreground-700">
                  <i className="ri-calendar-line text-accent-700"></i>
                  <span>年中無休</span>
                </div>
                <div className="flex items-center gap-2 text-foreground-700">
                  <i className="ri-truck-line text-accent-700"></i>
                  <span>京都市対応</span>
                </div>
                <div className="flex items-center gap-2 text-foreground-700">
                  <i className="ri-shield-check-line text-accent-700"></i>
                  <span>各種許可番号取得済</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}